import { useEffect, useRef, useCallback } from 'react'
import { Alert, BackHandler, AppState, AppStateStatus } from 'react-native'
import JailMonkey from 'jail-monkey'
import { useFocusEffect } from '@react-navigation/native'
import { isProduction } from '@/utils/environment'

const IS_PROD = isProduction() && !__DEV__
const isPlayReviewDevice = () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fingerprint = (JailMonkey as any).getBuildFingerprint?.() || ''
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const model = (JailMonkey as any).getModel?.() || ''
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const brand = (JailMonkey as any).getBrand?.() || ''

    // Detectar dispositivos de testing de Google Play
    return (
      fingerprint.includes('google/sdk_gphone') ||
      fingerprint.includes('generic/sdk') ||
      model.toLowerCase().includes('sdk_gphone') ||
      (brand.toLowerCase() === 'google' && model.toLowerCase().includes('sdk'))
    )
  } catch {
    return false
  }
}

export const useCheckSecurity = () => {
  const appState = useRef<AppStateStatus>(AppState.currentState)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const validateSecurity = useCallback(async () => {
    const isRooted = JailMonkey.isJailBroken()
    const isDebugged = await JailMonkey.isDebuggedMode()
    const isDevSettings = await JailMonkey.isDevelopmentSettingsMode()
    const isOnExternal = JailMonkey.isOnExternalStorage()
    const isAdbEnabled = JailMonkey.AdbEnabled()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isEmulator = (JailMonkey as any).isRunningOnEmulator?.()
    const isPlayReview = isPlayReviewDevice()
    // Solo bloquear emuladores que NO sean de Google Play

    if (
      (isRooted ||
        isDebugged ||
        isDevSettings ||
        isOnExternal ||
        isAdbEnabled ||
        (isEmulator && !isPlayReview)) &&
      IS_PROD
    ) {
      Alert.alert(
        'Dispositivo no permitido',
        'Por seguridad, esta aplicación no puede ejecutarse en este dispositivo.',
        [{ text: 'Salir', onPress: () => BackHandler.exitApp() }],
      )
    }
  }, [])
  useEffect(() => {
    const handleAppStateChange = (nextAppState: AppStateStatus) => {
      if (appState.current.match(/inactive|background/) && nextAppState === 'active') {
        validateSecurity()
      }
      appState.current = nextAppState
    }
    const subscription = AppState.addEventListener('change', handleAppStateChange)
    validateSecurity()
    intervalRef.current = setInterval(() => {
      validateSecurity()
    }, 10000)
    return () => {
      subscription.remove()
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [validateSecurity])
  useFocusEffect(
    useCallback(() => {
      validateSecurity()
    }, [validateSecurity]),
  )
}
